document.addEventListener('DOMContentLoaded', function () {
  const splide = new Splide('.js-color-slider', {
    type: 'loop',
    perPage: 1,
    focus: 'center',
    gap: '10px',
    padding: {
      left: '27%',
      right: '27%',
    },
    arrows: false,
    pagination: false,
    autoplay: true,    // 自動再生ON
    interval: 3000,    // 再生間隔（ミリ秒）
    pauseOnHover: false, // ホバーで一時停止
    pauseOnFocus: false, // フォーカスで止めない
    speed: 1000,        // スライド切り替えの速度
    breakpoints: {
      768: {
        perPage: 1,
        padding: {
          left: '13%',
          right: '13%',
        },
      }
    }
  }).mount();
  // 自作ボタンで制御
  document.querySelector('.js-color-slider-arrow.prev').addEventListener('click', () => splide.go('<'));
  document.querySelector('.js-color-slider-arrow.next').addEventListener('click', () => splide.go('>'));
})